<template>
  <!-- When loading -->
  <Loading v-if="!items" />

  <div v-else class="NavMenu" role="menu" ref="rt">
    <NavMenuItem v-for="item in items" :key="item.id" :item="item" :level="0" :parent="null" :evolutionDisable="evolutionDisable" :keepOneLevelOpen="keepOneLevelOpen" :branchAction="$props.branchAction" />
  </div>
</template>

<script>
  export default {
    name: 'NavMenu',
    components: {
      Loading: () => import('@/components/ui/Loading'),
      NavMenuItem: () => import('@/components/ui/NavMenuItem')
    },
    props: {
      evolutionDisable: {
        type: Boolean,
        default: false
      },
      items: Array,

      /**
       * selectedCallback é uma funcão que vem através do prop de NavMenu e será executada quando um nó folha no menu for selecionado. 
       * selectedCallback é injetado diretamente em todos os NavMuneuItem usando provide/inject do vue.
       * @param callerComponent: componente vue selecionado
       */
      selectedCallback: Function,
      branchAction: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        selected: null
      }
    },
    provide() {
      return {
        selectedCallback: this.selectedCallback || function () { },

        /**
         * levelClickedCallback função executada ao clicar em cada sub-menu da árvore.
         * Ela anima a árvore de sumário, movendo para a direita a barra de rolagem e mantendo o foco do usuário nos itens recentemente mostrados
         * @param level: nível de profundidade da árvore
         */
        levelClickedCallback: function (level) {
          let elem = this.$refs['rt']
          if (elem) {
            let ml = level * 26
            $(elem).animate({
              scrollLeft: ml
            })
          }
        }
      }
    },
    methods: {
      closeBranch (selectedItem, newNode) {
        /*
        function recursiveCloseNavMenuItem (currentVueNode, newVueNode) {
          if (!currentVueNode) return;
          if (newVueNode === currentVueNode) return; // interrompe a recusividade se newVueNode for um nó pai dentro do mesmo branch
          if (currentVueNode.parent && currentVueNode.parent.$children.find(x => x === newVueNode)) return;  // interrompe também se newVueNode for irmão de algum nó pai

          currentVueNode.close()
          recursiveCloseNavMenuItem(currentVueNode.parent, newVueNode)
        }

        recursiveCloseNavMenuItem(selectedItem, newNode)
        */
        let selectedParents = [selectedItem].concat(selectedItem.getAllParents()).reverse()
        let newParents = [newNode].concat(newNode.getAllParents()).reverse()
        let nodeToClose = null

        for (let i = 0; i < newParents.length; i++) {
          if (newParents[i] != selectedParents[i]) {
            nodeToClose = selectedParents[i]
          }
        }

        if (nodeToClose) {
          nodeToClose.close()
        }
      },
      keepOneLevelOpen (newNode) {
        if (this.selected === newNode) return
        
        if (this.selected === null) {
          this.selected = newNode
          return
        }
        
        if (newNode) {
          this.closeBranch(this.selected, newNode)
        }

        this.selected = newNode
      },
    }
  }
</script>
